<template>
  <div class="base-card-info">
    <div class="info-card-title">
      订单信息
    </div>
    <div class="custom-base-info tbl">
      <!-- 总笔数 -->
      <div class="item">
        <div class="label">
          总笔数
        </div>
        <div class="value">
          {{ info.totalNum || '--' }}
        </div>
      </div>
      <!-- 结算金额 -->
      <div class="item">
        <div class="label">
          结算金额
        </div>
        <div class="value">
          {{ isNull(info.settlementAmount) ? '--' : `${info.settlementAmount}元` }}
        </div>
      </div>
      <!-- 企业服务费 -->
      <div class="item">
        <div class="label">
          <el-tooltip
            effect="dark"
            placement="top"
            content="企业服务费=结算金额*服务主体配置中企业服务费率"
          >
            <svg-icon icon="mingcute:information-line" />
          </el-tooltip>
          <span>企业服务费</span>
        </div>
        <div class="value">
          {{ isNull(info.companyServiceAmount) ? '--' : `${info.companyServiceAmount}元` }}
        </div>
      </div>
      <!-- 个人服务费 -->
      <div class="item">
        <div class="label">
          <el-tooltip
            effect="dark"
            placement="top"
            content="服务费=结算金额*服务费率，再根据个人分摊比例，计算个人服务费"
          >
            <svg-icon icon="mingcute:information-line" />
          </el-tooltip>
          <span>个人服务费</span>
        </div>
        <div class="value">
          {{ isNull(info.personServiceAmount) ? '--' : `${info.personServiceAmount}元` }}
        </div>
      </div>
      <!-- 个人到账金额 -->
      <div class="item">
        <div class="label">
          <el-tooltip
            effect="dark"
            placement="top"
            content="个人实际到账金额合计"
          >
            <svg-icon icon="mingcute:information-line" />
          </el-tooltip>
          <span>个人到账金额</span>
        </div>
        <div class="value">
          {{ isNull(info.receivedAmount) ? '--' : `${info.receivedAmount}元` }}
        </div>
      </div>
      <!-- 个税金额 -->
      <div class="item">
        <div class="label">
          <el-tooltip
            effect="dark"
            placement="top"
            content="此订单需要支付的税金合计"
          >
            <svg-icon icon="mingcute:information-line" />
          </el-tooltip>
          <span>个税金额</span>
        </div>
        <div class="value">
          {{ isNull(info.taxAmount) ? '--' : `${info.taxAmount}元` }}
        </div>
      </div>
      <!-- 订单总金额 -->
      <div class="item">
        <div class="label">
          <el-tooltip
            effect="dark"
            placement="top"
            content="订单总金额=企业服务费+个人服务费+到账金额+个税金额，即为企业实际需要支付金额"
          >
            <svg-icon icon="mingcute:information-line" />
          </el-tooltip>
          <span>订单总金额</span>
        </div>
        <div class="value">
          {{ isNull(info.orderAmount) ? '--' : `${info.orderAmount}元` }}
        </div>
      </div>
      <!-- 成功金额 -->
      <div class="item">
        <div class="label">
          成功金额
        </div>
        <div class="value">
          {{ isNull(info.successAmount) ? '--' : `${info.successAmount}元` }}
        </div>
      </div>
      <!-- 失败金额 -->
      <div class="item">
        <div class="label">
          失败金额
        </div>
        <div class="value">
          {{ isNull(info.failAmount) ? '--' : `${info.failAmount}元` }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { isNull } from '@core/tools';
import { SvgIcon } from '@vue3/components';
import { ISettlementOrderDetail } from '@core/main/types';
import { PropType } from 'vue';

defineProps({
  info: {
    type: Object as PropType<ISettlementOrderDetail>,
    required: true,
  },
  term: {
    type: String as PropType<'company' | 'agent' | 'saas' | 'server'>,
    required: true,
  },
});
</script>
